import echo from './echo';

// Global events go here
export default function sockets(store) {
  const channels = [];
  let hasConnected = false;

  const listenForNewMessages = (uid) => {
    echo
      .private(`conversations.${uid}`)
      .listen('update', (e) => {
        // mark latest_log as read if it has been written by the current user
        if (
          e.conversation?.latest_log?.user_id === store.getters['users/me']?.id
        ) {
          e.conversation.latest_log.read = true;
        }

        store.dispatch('conversations/updateLatestLog', {
          conversationId: e.conversation.id,
          log: e.conversation.latest_log,
        });
        store.commit('conversationLogs/mergeLogs', {
          id: e.conversation.id,
          logs: [e.conversation.latest_log],
          action: 'append',
        });
      })
      .listen('unread', ({ unread }) => {
        store.commit('conversations/setUnreadCount', unread);
      });

    channels.push(`conversations.${uid}`);
  };

  const leaveAllChannels = () => {
    while (channels.length) {
      echo.leave(channels.shift());
    }
  };

  store.subscribe((mutation) => {
    if (mutation.type === 'users/set_me' && !hasConnected) {
      // When we aren't logged in we set a fake id for the user to be able
      // to query split. But this results in a request to `/me` which
      // returns a 401 which provokes a redirect in the app. As we don't
      // want this, we disable the websocket. This disables the websocket
      // on the lead contract view, but it wasn't working anyway as it
      // was started with the user id 0 which doesn't exist. We would need
      // to start it with the user id that we get from the contract or conversation
      // logs or something.
      if (mutation.payload.id === 0) return;

      listenForNewMessages(mutation.payload.id);
      hasConnected = true;
    }

    if (mutation.type === 'auth/clearToken') {
      leaveAllChannels();
    }
  });
}
